module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/related/vi/5-c8ae2b44f78b59634e3dd1a86a000cd9.jpg";